export default __webpack_public_path__ + "./images/adultContentLogo.a25ff60a.svg";